import { INTER } from '../../styles/fonts'
import { Container, TitleContainer, OptionalText, StyledInput, ErrorText } from './TextInput.styles'
import { forwardRef } from 'react'

export interface TextInputProps {
    title?: string
    defaultTitle: string
    value?: string
    isOptional?: boolean
    optionalLabel: string
    isError?: boolean
    errorText?: string
    defaultErrorText: string
    borderless?: boolean
    placeholder?: string
    defaultPlaceholder: string
    fontSize?: string
    fontFamily?: string
    inputMode?: 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url'
    disabled?: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({
    title,
    defaultTitle,
    value,
    isOptional = false,
    optionalLabel,
    isError = false,
    errorText,
    defaultErrorText,
    borderless = false,
    fontSize = '13px',
    fontFamily = INTER.regular,
    placeholder,
    defaultPlaceholder,
    inputMode,
    disabled,
    onChange,
    onBlur,
    onFocus,
    onKeyDown
}, ref) => {
    return (
        <Container>
            <TitleContainer>
                {title || defaultTitle}
                {isOptional && <OptionalText>{optionalLabel}</OptionalText>}
            </TitleContainer>
            <StyledInput
                ref={ref}
                placeholder={placeholder || defaultPlaceholder}
                value={value || ''}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                inputMode={inputMode}
                $isError={isError}
                $borderless={borderless}
                disabled={disabled}
                style={{
                    fontSize,
                    fontFamily
                }}
            />
            {isError && <ErrorText>{errorText || defaultErrorText}</ErrorText>}
        </Container>
    )
})

export default TextInput
